import { ColumnTitleProps, ColumnType } from 'antd/es/table/interface';
import { antdTableSortToDirection } from './TableColumnSort';

export function getSortOrderFromTitleProps<T>(
  column?: ColumnType<T>,
  sortColumns?: ColumnTitleProps<T>['sortColumns'],
) {
  if (!column || !sortColumns) return null;
  const sorted =
    sortColumns &&
    sortColumns.find(table => table.column.dataIndex === column.dataIndex);
  return sorted ? antdTableSortToDirection(sorted.order) : null;
}

export interface TableDataHederCellProps<T> {
  column?: ColumnType<T>;
  titleProps?: ColumnTitleProps<T>;
}
/**
 * Cella di Tabella (Header) per miglioratre la visualizzazione dell'ordinamento
 */
export function TableDataHeaderSortCell<T>(props: TableDataHederCellProps<T>) {
  const { column, titleProps } = props;
  if (!column || !titleProps) return null;

  const titleBefore = column.title as JSX.Element;

  return titleBefore;
}
